import React, { useRef, useEffect, useState, useContext } from "react";
import Item from "../Item/Item";
import arrow from "../../assets/arrow.png";

const AllProducts = () => {
  const databaseUrl = process.env.REACT_APP_DATABASE_URL;
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [totalProducts, setTotalProducts] = useState(0);

  const fetchProducts = async () => {
    if (isLoading) return;
    setIsLoading(true);

    try {
      const response = await fetch(
        `${databaseUrl}/allproducts?limit=10&page=${page}`
      );
      if (!response.ok) throw new Error("Failed to fetch products");

      const data = await response.json();

      setProducts((prev) => [...prev, ...data.products]);
      setTotalProducts(data.total);

      if (products.length + data.products.length >= data.total) {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [page]);

  const loadMore = () => {
    if (hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;
    const handleScroll = () => {
      clearTimeout(window.scrollTimeout);
      window.scrollTimeout = setTimeout(() => {
        const container = scrollContainer;
        const items = container.querySelectorAll(".item");
        const containerRect = container.getBoundingClientRect();
        const containerCenterX = containerRect.left + containerRect.width / 2;

        let closestItem;
        let minDistance = Infinity;

        items.forEach((item) => {
          const itemRect = item.getBoundingClientRect();
          const itemCenterX = itemRect.left + itemRect.width / 2;
          const distance = Math.abs(itemCenterX - containerCenterX);

          if (distance < minDistance) {
            closestItem = item;
            minDistance = distance;
          }
        });

        if (closestItem) {
          container.scrollTo({
            left:
              closestItem.offsetLeft -
              container.offsetWidth / 2 +
              closestItem.offsetWidth / 2,
            behavior: "smooth",
          });
        }
      }, 150);
    };

    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [scrollContainerRef.current]);

  return (
    <div className="mt-16 mb-20 px-[3%] md:px-[5%] lg:px-[10%]">
      <h1 className="text-4xl md:text-5xl text-center font-medium mb-12 text-[#551E19]">
        ALL PRODUCTS
      </h1>
      <div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4"
        ref={scrollContainerRef}
      >
        {products.map((item) => (
          <div className="font-montserrat" key={item._id}>
            <Item
              id={item.id}
              name={item.name}
              image={item.image}
              new_price={item.new_price}
              old_price={item.old_price}
              rating={item.rating}
              reviewText={item.reviewText}
              no_of_rators={item.no_of_rators}
              category={item.category}
              available={item.available}
            />
          </div>
        ))}
      </div>
      {hasMore && !isLoading && (
        <div className="py-6 flex items-center justify-center mt-8">
          <button
            onClick={loadMore}
            className="bg-[#E6B17E] text-[#551e19] px-7 py-3 text-lg rounded-3xl hover:bg-[#c98c3c] flex items-center font-oswald"
          >
            Load More <img src={arrow} className="ml-2 h-4 w-4" />
          </button>
        </div>
      )}

      {isLoading && <p className="mt-4">Loading...</p>}

      {!hasMore && !isLoading && (
        <p className="text-[#551e19] text-xs mt-5 text-center">
          No more products to load.
        </p>
      )}
    </div>
  );
};

export default AllProducts;
